@let _features = features();

@if (allData?.length) {
  <sd-accordion-group [closeOthers]="false" [clickOutsideToClose]="false">
    @for (data of allData; track (data.code || $index)) {
      @if (data.name || _features?.title) {
        <sd-accordion
          [title]="data.name || _features.title"
          [titleLevel]="3"
          titleCustomClass="brand--h4"
          [iconSize]="iconSize"
          [isOpened]="$first && (!_features.title || isOpen())"
          iconNameOpened="icon-arrow-up"
          iconNameClosed="icon-arrow-down"
          [iconPos]="positionEnum.left"
          [theme]="themesTextEnum.brand"
          [ngClass]="{ 'has-subtitle': _features?.subtitle }"
        >
          @if (!data.name && _features?.subtitle) {
            <sd-title
              class="c__subtitle"
              [titleLevel]="1"
              [isDescription]="true"
              [customClass]="customClassSubtitle"
            >
              {{ _features.subtitle }}
            </sd-title>
          }
          <ng-container *ngTemplateOutlet="tableTemplate; context: {
              maxline: data.maxLine,
              entries: data.entries,
              columns: data.columns
            }"
          />

          @if (_features?.footNotes?.length) {
            <sd-footnote [footNotes]="_features.footNotes" [isLoading]="isLoading()" />
          }
        </sd-accordion>
      } @else {
        <div class="has-no-accordion">
          <ng-container *ngTemplateOutlet="tableTemplate; context: {
            maxline: data.maxLine,
            entries: data.entries,
            columns: data.columns
          }" />
        </div>
      }
    }
  </sd-accordion-group>
}

<!-- Table Template -->
<ng-template #tableTemplate let-maxline="maxline" let-entries="entries" let-columns="columns">
  <sd-table
    [titleLevel]="2"
    class="is-table-flex"
    [verticalLayout]="true"
    [maxLine]="maxline"
    [entries]="entries"
    [columns]="columns"
  />
</ng-template>
